import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import _defineProperty from "/data/landun/workspace/vft-activities/d2d-welfare/codebase/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { mapState } from 'vuex'; // import { env } from '@tencent/vft-common'

import Avatar from '@tencent/vft-ui/src/Avatar/Avatar.vue';
import VipIcon from '@tencent/vft-ui/src/VipIcon/VipIcon.vue';
import VftQrcode from '@tencent/vft-ui/src/Qrcode/Qrcode';
import PicShare from '@/components/UI/PicShare/PicShare';
import Nick from '@/components/UI/Nick';
import globalSetting from '@/setting';
export default {
  name: 'Invite',
  settingKey: '邀请碰蛋弹框',
  setting: {
    弹框背景: 'https://puui.qpic.cn/vupload/0/20190620_1561020048004_03devzv96t1a.png/0',
    // 右图: 'https://puui.qpic.cn/vupload/0/20190620_1561100795415_ijn0r74rm99.png/0',
    奖品图: 'https://puui.qpic.cn/vupload/0/20190620_1561020655535_ozj6mne2ugm.png/0',
    peng: 'https://puui.qpic.cn/vupload/0/20190620_1561103042675_moigs634cr.png/0',
    标题: {
      type: 'expression',
      default: '在腾讯视频VIP福利社，获得${egg_count}颗${egg_name}',
      variables: ['egg_count', 'egg_name']
    },
    文案: '长按扫码跟我碰，有机会获得<span>18888元</span><br>大奖哦！进入福利社领取万千好礼～',
    分享配置: {
      type: 'object',
      properties: {
        分享标题: '做整个村最闪亮的蛋仔！碰蛋就有机会得最高18888元现金大奖！',
        分享描述: '做整个村最闪亮的蛋仔！碰蛋就有机会得最高18888元现金大奖！',
        分享朋友圈标题: '做整个村最闪亮的蛋仔！碰蛋就有机会得最高18888元现金大奖！',
        分享图: 'https://puui.qpic.cn/vupload/0/20190620_1561100795415_ijn0r74rm99.png/0',
        二维码Ptag: 'ptag=luckyeggshare',
        分享Ptag: 'ptag=luckyeggshare2'
      }
    },
    碰蛋文案: 'VIP福利社彩蛋等你来碰'
  },
  components: {
    Nick: Nick,
    PicShare: PicShare,
    Avatar: Avatar,
    VipIcon: VipIcon,
    VftQrcode: VftQrcode
  },
  computed: _objectSpread(_objectSpread({}, mapState('bump', ['myEggInfo', 'myShareCode'])), {}, {
    shareCodeUrl: function shareCodeUrl() {
      var currentPageUrl = location.href.split('?')[0];
      return currentPageUrl + "?shareCode=".concat(this.myShareCode);
    },
    qrcodeUrl: function qrcodeUrl() {
      return this.shareCodeUrl + '&' + this.setting.分享配置.二维码Ptag;
    },
    右图: function 右图() {
      return globalSetting.默认蛋图片;
    }
  }),
  mounted: function mounted() {
    var 分享配置 = this.setting.分享配置;
    this.share.setShare(Object.assign({
      imgUrl: 分享配置.分享图,
      title: 分享配置.分享标题,
      desc: 分享配置.分享描述,
      timeLineTitle: 分享配置.分享朋友圈标题,
      link: this.shareCodeUrl + '&' + 分享配置.分享Ptag
    }));
  }
};